var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#1457A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33008 29.3091C7.33008 29.4926 8.42223 29.6686 10.3663 29.7983C12.3103 29.9281 14.947 30.001 17.6963 30.001C20.4456 30.001 23.0823 29.9281 25.0264 29.7983C26.9704 29.6686 28.0626 29.4926 28.0626 29.3091C28.0626 29.1256 26.9704 28.9496 25.0264 28.8198C23.0823 28.6901 20.4456 28.6172 17.6963 28.6172C14.947 28.6172 12.3103 28.6901 10.3663 28.8198C8.42223 28.9496 7.33008 29.1256 7.33008 29.3091Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5912 26.4688H6.4088C6.30038 26.4688 6.1964 26.509 6.11973 26.5807C6.04307 26.6523 6 26.7495 6 26.8508V28.1723H30V26.8508C30 26.7495 29.9569 26.6523 29.8803 26.5807C29.8036 26.509 29.6996 26.4688 29.5912 26.4688Z",
    fill: "white",
    stroke: "#1457A8",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.1699H6C6.18265 28.5112 6.46338 28.7983 6.81074 28.9989C7.15811 29.1995 7.55838 29.3058 7.96672 29.3057H28.0431C28.4484 29.3055 28.8456 29.2 29.1904 29.0009C29.5352 28.8018 29.814 28.517 29.9955 28.1783L30 28.1699Z",
    fill: "white",
    stroke: "#1457A8",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.359 14.543H8.63986C8.42302 14.543 8.21506 14.6235 8.06173 14.7668C7.9084 14.9101 7.82227 15.1044 7.82227 15.3071V26.4674H28.1766V15.3071C28.1766 15.1044 28.0905 14.9101 27.9372 14.7668C27.7838 14.6235 27.5759 14.543 27.359 14.543Z",
    fill: "white",
    stroke: "#1457A8",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6871 11.5352C21.7938 11.5349 21.8983 11.5068 21.9887 11.454C22.0792 11.4012 22.1521 11.3258 22.1991 11.2363C22.2462 11.1468 22.2656 11.0469 22.2551 10.9476C22.2445 10.8484 22.2046 10.7539 22.1397 10.6748L18.4531 6.20718C18.3996 6.14269 18.3311 6.09049 18.2527 6.05458C18.1743 6.01867 18.0881 6 18.0008 6C17.9135 6 17.8273 6.01867 17.7489 6.05458C17.6705 6.09049 17.602 6.14269 17.5485 6.20718L13.8619 10.6729C13.7964 10.752 13.756 10.8467 13.7451 10.9462C13.7343 11.0457 13.7535 11.1461 13.8007 11.2359C13.8478 11.3257 13.9209 11.4013 14.0118 11.4542C14.1026 11.5072 14.2075 11.5352 14.3145 11.5352H15.715V16.0728C15.715 16.3565 15.8356 16.6286 16.0503 16.8292C16.2649 17.0298 16.5561 17.1425 16.8596 17.1425H19.1452C19.4488 17.1425 19.7399 17.0298 19.9546 16.8292C20.1693 16.6286 20.2899 16.3565 20.2899 16.0728V11.5352H21.6871Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6871 11.5352C21.7938 11.5349 21.8983 11.5068 21.9887 11.454C22.0792 11.4012 22.1521 11.3258 22.1991 11.2363C22.2462 11.1468 22.2656 11.0469 22.2551 10.9476C22.2445 10.8484 22.2046 10.7539 22.1397 10.6748L18.4531 6.20718C18.3996 6.14269 18.3311 6.09049 18.2527 6.05458C18.1743 6.01867 18.0881 6 18.0008 6C17.9135 6 17.8273 6.01867 17.7489 6.05458C17.6705 6.09049 17.602 6.14269 17.5485 6.20718L13.8619 10.6729C13.7964 10.752 13.756 10.8467 13.7451 10.9462C13.7343 11.0457 13.7535 11.1461 13.8007 11.2359C13.8478 11.3257 13.9209 11.4013 14.0118 11.4542C14.1026 11.5072 14.2075 11.5352 14.3145 11.5352H15.715V16.0728C15.715 16.3565 15.8356 16.6286 16.0503 16.8292C16.2649 17.0298 16.5561 17.1425 16.8596 17.1425H19.1452C19.4488 17.1425 19.7399 17.0298 19.9546 16.8292C20.1693 16.6286 20.2899 16.3565 20.2899 16.0728V11.5352H21.6871Z",
    stroke: "#1457A8",
    strokeWidth: 0.9,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2871 18.2812H19.7157V19.8832H16.2871V18.2812Z",
    fill: "white",
    stroke: "#1457A8",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5703 20.9531H19.4274V22.555H16.5703V20.9531Z",
    fill: "white",
    stroke: "#1457A8",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBorder);
export default __webpack_public_path__ + "static/media/upload-border.6858ed48ebafb7bc5c0805fd1460c1aa.svg";
export { ForwardRef as ReactComponent };